import React, { useEffect, useState } from 'react';
import './App.css';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import FinancesPage from './components/FinancesPage';
import ConversionsPage from './components/ConversionsPage';
import ExpensesPage from './components/ExpensesPage';
import FbAccountsPage from './components/FbAccountsPage';
import SpendModelPage from './components/SpendModelPage';
import MyOrdersPage from './components/MyOrdersPage';
import OrderSuppliesPage from './components/OrderSuppliesPage';
import LoginPage from './components/LoginPage';
import PayoutsPage from './components/PayoutsPage';
import InfoPage from './components/InfoPage';
import ConversionControlPage from './components/ConversionControlPage';
import { initializeData } from './data/dataService';

const SESSION_KEY = 'tj_session';

function App() {
  const [dataState, setDataState] = useState('loading');
  const [user, setUser] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem(SESSION_KEY)); } catch { return null; }
  });

  useEffect(() => {
    initializeData()
      .then((data) => {
        setUser((sessionUser) => {
          if (!sessionUser) return sessionUser;
          const databaseUser = (data.users || []).find(
            (item) => item.id === sessionUser.id || item.email === sessionUser.email,
          );
          if (!databaseUser) return sessionUser;
          const refreshedUser = { ...sessionUser, ...databaseUser };
          sessionStorage.setItem(SESSION_KEY, JSON.stringify(refreshedUser));
          return refreshedUser;
        });
        setDataState('ready');
      })
      .catch(() => setDataState('error'));
  }, []);

  const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth > 768);
  const [activePage, setActivePage]   = useState('info-settings');

  const handleLogin = (u) => {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(u));
    setUser(u);
  };

  const handleLogout = () => {
    sessionStorage.removeItem(SESSION_KEY);
    setUser(null);
  };

  const handleUserUpdate = (updatedUser) => {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(updatedUser));
    setUser(updatedUser);
  };

  if (dataState === 'loading') {
    return (
      <div className="app-loading" role="status" aria-live="polite">
        <span className="app-loading__spinner" aria-hidden="true" />
        <span className="app-loading__text">Загрузка данных…</span>
      </div>
    );
  }
  if (dataState === 'error') {
    return <div className="app-loading app-loading--error">Не удалось подключиться к базе данных</div>;
  }
  if (!user) return <LoginPage onLogin={handleLogin} />;

  // Hidden utility page: intentionally not exposed in the sidebar.
  if (window.location.pathname.replace(/\/+$/, '') === '/cc') {
    return <ConversionControlPage />;
  }

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  const handleNavigate = (page) => {
    setActivePage(page);
    if (window.innerWidth <= 768) setSidebarOpen(false);
  };

  return (
    <div className="app">
      <Header onToggleSidebar={toggleSidebar} title="Главная страница" onLogout={handleLogout} />

      <Sidebar
        isOpen={sidebarOpen}
        activePage={activePage}
        onNavigate={handleNavigate}
        user={user}
      />

      {sidebarOpen && (
        <div className="overlay" onClick={() => setSidebarOpen(false)} />
      )}

      <main className={`app__content ${sidebarOpen ? 'app__content--shifted' : ''}`}>
        {activePage === 'info-settings' && <InfoPage user={user} onUserUpdate={handleUserUpdate} />}
        {activePage === 'reports'      && <FinancesPage onNavigate={handleNavigate} />}
        {activePage === 'conversions'  && <ConversionsPage />}
        {activePage === 'expenses'     && <ExpensesPage />}
        {activePage === 'fb-accounts'  && <FbAccountsPage />}
        {activePage === 'spend-model'  && <SpendModelPage />}
        {activePage === 'my-orders'      && <MyOrdersPage user={user} />}
        {activePage === 'order-supplies'  && <OrderSuppliesPage />}
        {activePage === 'payouts'           && <PayoutsPage />}
      </main>
    </div>
  );
}

export default App;
